"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReference = exports.updateOwnerOrPerformer = exports.saveEvaluationItem = exports.updateEvaluationData = exports.updateProgressState = exports.updateWeakStateData = exports.updateWeakState = exports.updateEvaluationWithFile = void 0;
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var firebase = __importStar(require("../firebase/fbase"));
var StaffManager = __importStar(require("../rcm/StaffManager"));
var storage = __importStar(require("../storage/StorageManager"));
var EvaluationLoader_1 = require("./EvaluationLoader");
var EvaluationRemover_1 = require("./EvaluationRemover");
var EvaluationUtils_1 = require("./EvaluationUtils");
function updateResultState(evalType, evaluationName, controlId, resultState) {
    return __awaiter(this, void 0, void 0, function () {
        var documentRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    documentRef = firebase.dbService
                        .collection(Evaluation.getKoEvaluation(evalType))
                        .doc(evaluationName)
                        .collection(EvaluationUtils_1.STATE_DOC_NAME)
                        .doc(controlId);
                    return [4 /*yield*/, documentRef.update({
                            resultState: resultState,
                            resultStateUpdateTime: (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss')
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function updateEvaluationWithFile(evalType, evaluationName, files) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var editable, currentUserId, currentTime, controlIds, updatedExcelControlIds, contents;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = firebase.authService.currentUser) === null || _a === void 0 ? void 0 : _a.email)) {
                        return [2 /*return*/, Promise.reject(new Error('파일 업데이트- 로그인한 유저를 찾을 수 없습니다.'))];
                    }
                    return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(evalType, evaluationName)];
                case 1:
                    editable = _b.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("".concat(evaluationName, "\uC740 \uC774\uBBF8 \uB9C8\uAC10\uB418\uC5B4\uC11C \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    currentUserId = firebase.authService.currentUser.email;
                    currentTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                    controlIds = (0, lodash_1.default)(files)
                        .map(function (file) { return file.controlId; })
                        .uniq()
                        .value();
                    updatedExcelControlIds = [];
                    return [4 /*yield*/, (0, EvaluationLoader_1.getContentsWithIds)(evalType, evaluationName, controlIds)];
                case 2:
                    contents = _b.sent();
                    lodash_1.default.forEach(files, function (originalFile) {
                        var file = lodash_1.default.cloneDeep(originalFile);
                        lodash_1.default.unset(file, 'file'); // firebase에는 File을 저장하지 않고 firestore에 저장
                        file.evaluationName = evaluationName;
                        file.updateTime = currentTime;
                        file.updater = currentUserId;
                        file.state = BaseFile_1.FileState.OK;
                        if (file.type === BaseFile_1.FileType.Record) {
                            var recordFile = file;
                            contents[file.controlId].files.record = recordFile;
                            if (recordFile.excelData &&
                                !Evaluation.isTableContent(recordFile.excelData) &&
                                (Evaluation.isOperationEvaluation(recordFile.excelData) ||
                                    Evaluation.isDesignEvaluation(recordFile.excelData))) {
                                contents[file.controlId].data = recordFile.excelData;
                            }
                            contents[file.controlId].data.updateTime = currentTime;
                            updatedExcelControlIds.push(file.controlId);
                        }
                        else if (file.type === BaseFile_1.FileType.Population) {
                            var newFile = lodash_1.default.cloneDeep(file);
                            lodash_1.default.unset(newFile, 'excelData');
                            contents[file.controlId].files.population = newFile;
                        }
                        else if (file.type === BaseFile_1.FileType.Evidence) {
                            var evidence = contents[file.controlId].files.evidence;
                            if (evidence) {
                                evidence[file.name] = file;
                            }
                            else {
                                var newEvidence = {};
                                newEvidence[file.name] = file;
                                contents[file.controlId].files.evidence = newEvidence;
                            }
                        }
                        else {
                            var extra = contents[file.controlId].files.extra;
                            if (extra) {
                                extra[file.name] = file;
                            }
                            else {
                                var newExtra = {};
                                newExtra[file.name] = file;
                                contents[file.controlId].files.extra = newExtra;
                            }
                        }
                    });
                    return [4 /*yield*/, storage.uploadFilesForEvaluation(evalType, files)];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(contents, function (content, controlId) { return __awaiter(_this, void 0, void 0, function () {
                            var documentRef, newFiles;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        documentRef = firebase.dbService
                                            .collection(Evaluation.getKoEvaluation(evalType))
                                            .doc(evaluationName)
                                            .collection(EvaluationUtils_1.CONTENT_DOC_NAME)
                                            .doc(controlId);
                                        newFiles = lodash_1.default.filter(files, function (file) { return file.controlId === controlId; });
                                        return [4 /*yield*/, Promise.all(lodash_1.default.map(newFiles, function (newFile) { return __awaiter(_this, void 0, void 0, function () {
                                                var hasFile;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, storage.hasFile(evalType, evaluationName, controlId, newFile.name)];
                                                        case 1:
                                                            hasFile = _a.sent();
                                                            if (newFile.type === BaseFile_1.FileType.Record) {
                                                                content.files.record.checked = hasFile;
                                                            }
                                                            else if (newFile.type === BaseFile_1.FileType.Population && content.files.population) {
                                                                content.files.population.checked = hasFile;
                                                            }
                                                            else if (newFile.type === BaseFile_1.FileType.Evidence &&
                                                                content.files.evidence &&
                                                                newFile.name in content.files.evidence) {
                                                                content.files.evidence[newFile.name].checked = hasFile;
                                                            }
                                                            else if (newFile.type === BaseFile_1.FileType.Extra && newFile.name in content.files.extra) {
                                                                content.files.extra[newFile.name].checked = hasFile;
                                                            }
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); }))];
                                    case 1:
                                        _a.sent();
                                        if (!lodash_1.default.includes(updatedExcelControlIds, controlId)) return [3 /*break*/, 5];
                                        return [4 /*yield*/, documentRef.update({
                                                files: content.files,
                                                data: content.data
                                            })];
                                    case 2:
                                        _a.sent();
                                        if (!content.data.resultState) return [3 /*break*/, 4];
                                        return [4 /*yield*/, updateResultState(evalType, evaluationName, controlId, content.data.resultState)];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4: return [3 /*break*/, 7];
                                    case 5: return [4 /*yield*/, documentRef.update({ files: content.files })];
                                    case 6:
                                        _a.sent();
                                        _a.label = 7;
                                    case 7: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 4:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateEvaluationWithFile = updateEvaluationWithFile;
/**
 * weakState, weakStateUpdateTime 업데이트
 * @param evalType
 * @param evalName
 * @param controlId
 * @param finalState
 * @returns
 */
function updateWeakState(type, name, controlId, weakState) {
    return __awaiter(this, void 0, void 0, function () {
        var editable, currentTime, collectionName, docRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(type, name)];
                case 1:
                    editable = _a.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00(".concat(name, ")\uB294 \uC774\uBBF8 \uB9C8\uAC10\uB41C \uD3C9\uAC00\uC774\uAE30 \uB584\uBB38\uC5D0 \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    currentTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                    collectionName = Evaluation.getKoEvaluation(type);
                    docRef = firebase.dbService
                        .collection(collectionName)
                        .doc(name)
                        .collection(EvaluationUtils_1.STATE_DOC_NAME)
                        .doc(controlId);
                    return [4 /*yield*/, docRef.update({
                            weakState: weakState,
                            weakStateUpdateTime: currentTime
                        })];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.updateWeakState = updateWeakState;
/**
 * 평가-상태 의 weakStateData 업데이트
 * @param type
 * @param name
 * @param controlId
 * @param weakState
 * @param weakData
 * @returns
 */
function updateWeakStateData(type, name, controlId, weakState, weakData) {
    return __awaiter(this, void 0, void 0, function () {
        var editable, collectionName, docRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(type, name)];
                case 1:
                    editable = _a.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00(".concat(name, ")\uB294 \uC774\uBBF8 \uB9C8\uAC10\uB41C \uD3C9\uAC00\uC774\uAE30 \uB584\uBB38\uC5D0 \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    collectionName = Evaluation.getKoEvaluation(type);
                    docRef = firebase.dbService
                        .collection(collectionName)
                        .doc(name)
                        .collection(EvaluationUtils_1.STATE_DOC_NAME)
                        .doc(controlId);
                    return [4 /*yield*/, docRef.update({ weakStateData: weakData })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, updateWeakState(type, name, controlId, weakState)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateWeakStateData = updateWeakStateData;
/**
 * EvaluationItem의 ProgressState를 업데이트한다.
 * Performed(수행완료)로 바뀔 때는 accomplishTime 업데이트
 * Approved(승인완료)로 바뀔 때는 approvalTime, controlApprover 업데이트
 * @param type
 * @param name
 * @param controlIds
 * @param state
 */
function updateProgressState(type, name, controlIds, state) {
    return __awaiter(this, void 0, void 0, function () {
        var editable, currentTime, collectionName, stateCollectionRef;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(type, name)];
                case 1:
                    editable = _a.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00(".concat(name, ")\uB294 \uC774\uBBF8 \uB9C8\uAC10\uB41C \uD3C9\uAC00\uC774\uAE30 \uB584\uBB38\uC5D0 \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    currentTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                    collectionName = Evaluation.getKoEvaluation(type);
                    stateCollectionRef = firebase.dbService
                        .collection(collectionName)
                        .doc(name)
                        .collection(EvaluationUtils_1.STATE_DOC_NAME);
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(controlIds, function (controlId) { return __awaiter(_this, void 0, void 0, function () {
                            var docRef, userId, staffData, _a, evaluationStates, resultState;
                            var _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        docRef = stateCollectionRef.doc(controlId);
                                        if (!(state === Evaluation.ProgressState.Performed)) return [3 /*break*/, 1];
                                        // "3" 수행완료 => accomplishTime 도 업데이트 해야함
                                        return [2 /*return*/, docRef.update({
                                                accomplishTime: currentTime,
                                                state: state
                                            })];
                                    case 1:
                                        if (!(state === Evaluation.ProgressState.Approved &&
                                            ((_b = firebase.authService.currentUser) === null || _b === void 0 ? void 0 : _b.email))) return [3 /*break*/, 8];
                                        userId = firebase.authService.currentUser.email;
                                        _c.label = 2;
                                    case 2:
                                        _c.trys.push([2, 4, , 5]);
                                        return [4 /*yield*/, StaffManager.get(userId)];
                                    case 3:
                                        staffData = _c.sent();
                                        if (!staffData || staffData.level !== 'ADMIN') {
                                            return [2 /*return*/, Promise.reject(new Error('에러. 평가 승인완료 - 권한이 없습니다.'))];
                                        }
                                        return [3 /*break*/, 5];
                                    case 4:
                                        _a = _c.sent();
                                        return [2 /*return*/, Promise.reject(new Error('에러. 평가 승인완료 - 로그인한 유저를 찾을 수 없습니다.'))];
                                    case 5: return [4 /*yield*/, docRef.update({
                                            approvalTime: currentTime,
                                            state: state,
                                            controlApprover: userId
                                        })
                                        // 미비점 평가와 관련이 없는 컨트롤들은 resultState를 변경
                                    ];
                                    case 6:
                                        _c.sent();
                                        return [4 /*yield*/, (0, EvaluationLoader_1.getEvaluationStates)(type, name)];
                                    case 7:
                                        evaluationStates = _c.sent();
                                        resultState = evaluationStates[controlId].resultState;
                                        if (type === Evaluation.Type.Operation) {
                                            // 운영평가에서만 적용
                                            // resultState: "3" 이란 것은 평가 보고서의 결과 문제가 있어서 미비점의 평가 대상이란 말이다
                                            // 그럼 이 경우엔 승인완료 가 될 때 weakState 를 "2"(평가 대기 상태) 로 만들어주자
                                            updateWeakState(type, name, controlId, resultState === Evaluation.ResultState.Defect
                                                ? Evaluation.OperationWeakState.Pending
                                                : Evaluation.OperationWeakState.Default);
                                        }
                                        return [3 /*break*/, 14];
                                    case 8:
                                        if (!(state === Evaluation.ProgressState.Rejected)) return [3 /*break*/, 12];
                                        if (!(type === Evaluation.Type.Operation)) return [3 /*break*/, 10];
                                        return [4 /*yield*/, updateWeakState(type, name, controlId, Evaluation.OperationWeakState.Default)];
                                    case 9:
                                        _c.sent();
                                        _c.label = 10;
                                    case 10: return [4 /*yield*/, docRef.update({ state: state })];
                                    case 11:
                                        _c.sent();
                                        return [3 /*break*/, 14];
                                    case 12: 
                                    // "2": 수행중
                                    return [4 /*yield*/, docRef.update({ state: state })];
                                    case 13:
                                        // "2": 수행중
                                        _c.sent();
                                        _c.label = 14;
                                    case 14: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateProgressState = updateProgressState;
/**
 *   운영/설계평가의 보고서 내용을 업데이트한다(Web)
  이전에 보고서 파일이 업로드 된 적이 없다면 createDate 는 비어있게 되는데
  그러므로 파일이 업로드 된 적이 없는지 체크를 한 다음에 그렇다면 createDate 도 채워준다
  체크는 createDate 가 "" 인지 체크하면 될듯
 * @param type
 * @param name
 * @param item
 */
function updateEvaluationData(type, name, data) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var userId, editable, resultState, isValid, currentDate, currentTime, createDate, docRef;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userId = (_a = firebase.authService.currentUser) === null || _a === void 0 ? void 0 : _a.email;
                    if (!userId) {
                        return [2 /*return*/, Promise.reject(new Error('로그인한 유저를 찾을 수 없습니다.'))];
                    }
                    return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(type, name)];
                case 1:
                    editable = _b.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00(".concat(name, ")\uB294 \uC774\uBBF8 \uB9C8\uAC10\uB41C \uD3C9\uAC00\uC774\uAE30 \uB584\uBB38\uC5D0 \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    if (Evaluation.isOperationEvaluation(data)) {
                        isValid = Number(data.invalidCount) === 0;
                        resultState = isValid ? Evaluation.ResultState.Normal : Evaluation.ResultState.Defect;
                    }
                    else if (Evaluation.isDesignEvaluation(data)) {
                        resultState = data.resultState;
                    }
                    else {
                        return [2 /*return*/, Promise.reject(new Error('Invalid evaluation data'))];
                    }
                    currentDate = (0, moment_1.default)().format('YYYY-MM-DD');
                    currentTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                    return [4 /*yield*/, (0, EvaluationLoader_1.getCreateDateOfEvaluationItem)(type, name, data.controlId)];
                case 2:
                    createDate = _b.sent();
                    data.createDate = createDate || currentDate;
                    data.updateTime = currentTime;
                    docRef = firebase.dbService
                        .collection(Evaluation.getKoEvaluation(type))
                        .doc(name)
                        .collection(EvaluationUtils_1.CONTENT_DOC_NAME)
                        .doc(data.controlId);
                    return [4 /*yield*/, docRef.update({ data: data })
                        // 평가의 최종결과는 비유효 항목수에 의해 결정된다
                        // 이 경우 invalidCount 는 무조건 string 형태의 숫자 값이다.(예외 없음)
                    ];
                case 3:
                    _b.sent();
                    // 평가의 최종결과는 비유효 항목수에 의해 결정된다
                    // 이 경우 invalidCount 는 무조건 string 형태의 숫자 값이다.(예외 없음)
                    return [4 /*yield*/, updateResultState(type, name, data.controlId, resultState)];
                case 4:
                    // 평가의 최종결과는 비유효 항목수에 의해 결정된다
                    // 이 경우 invalidCount 는 무조건 string 형태의 숫자 값이다.(예외 없음)
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateEvaluationData = updateEvaluationData;
function saveEvaluationItem(type, name, evaluationItems, selectedDetailId, evaluationData, deletedFiles, newFiles, newState) {
    return __awaiter(this, void 0, void 0, function () {
        var selectedData, isNotModifiedContent, newEvaluationData, _i, deletedFiles_1, deletedFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (name === Evaluation.BASE_ITEM) {
                        throw new Error('not selected');
                    }
                    selectedData = lodash_1.default.find(evaluationItems, { controlId: selectedDetailId });
                    if (!selectedData) {
                        throw new Error('not selected');
                    }
                    isNotModifiedContent = lodash_1.default.every(evaluationData, function (v, k) {
                        return lodash_1.default.isEqual(v, lodash_1.default.get(selectedData === null || selectedData === void 0 ? void 0 : selectedData.content.data, k));
                    });
                    if (!(isNotModifiedContent && lodash_1.default.isEmpty(deletedFiles) && lodash_1.default.isEmpty(newFiles))) return [3 /*break*/, 3];
                    if (!(newState === Evaluation.ProgressState.Performed)) return [3 /*break*/, 2];
                    // NOTE: 수행완료 버튼을 눌렀을 경우, 변경사항이 없더라도 저장한다.
                    return [4 /*yield*/, updateProgressState(type, name, [selectedDetailId], newState)];
                case 1:
                    // NOTE: 수행완료 버튼을 눌렀을 경우, 변경사항이 없더라도 저장한다.
                    _a.sent();
                    return [2 /*return*/];
                case 2: throw new Error('not changed');
                case 3:
                    if (Evaluation.isOperationEvaluation(evaluationData) &&
                        evaluationData.samplingResult.columnCountIncludeNumbering === 2 &&
                        evaluationData.samplingResult.rowCountExceptHeader === 1 &&
                        lodash_1.default.isEqual(evaluationData.samplingResult.headerRow, ['No', '']) &&
                        lodash_1.default.isEqual(evaluationData.samplingResult.rowObjectList[0], { No: '1', '': '' })) {
                        evaluationData.samplingResult = {
                            headerRow: [],
                            columnCountIncludeNumbering: 0,
                            rowCountExceptHeader: 0,
                            rowObjectList: []
                        };
                    }
                    else if (Evaluation.isOperationEvaluation(evaluationData) &&
                        lodash_1.default.some(evaluationData.samplingResult.headerRow, function (header) { return lodash_1.default.isEmpty(header); })) {
                        throw new Error('empty header');
                    }
                    if (!!isNotModifiedContent) return [3 /*break*/, 5];
                    newEvaluationData = lodash_1.default.cloneDeep(evaluationData);
                    if (Evaluation.isOperationEvaluation(newEvaluationData)) {
                        // TODO(sangmuk): Set controlExecutor after set login.
                        lodash_1.default.assign(newEvaluationData, {
                            samplingCount: newEvaluationData.samplingCount.toString(),
                            populationTableColumnCount: newEvaluationData.populationTableColumnCount.toString(),
                            samplingAttributeCount: newEvaluationData.samplingAttributeCount.toString()
                        });
                    }
                    return [4 /*yield*/, updateEvaluationData(type, name, newEvaluationData)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    if (!!lodash_1.default.isEmpty(deletedFiles)) return [3 /*break*/, 9];
                    _i = 0, deletedFiles_1 = deletedFiles;
                    _a.label = 6;
                case 6:
                    if (!(_i < deletedFiles_1.length)) return [3 /*break*/, 9];
                    deletedFile = deletedFiles_1[_i];
                    // NOTE: 파일 하나씩 삭제해야 데이터베이스에 쓰레기값이 안남음
                    return [4 /*yield*/, (0, EvaluationRemover_1.removeFileInEvaluation)(deletedFile)];
                case 7:
                    // NOTE: 파일 하나씩 삭제해야 데이터베이스에 쓰레기값이 안남음
                    _a.sent();
                    _a.label = 8;
                case 8:
                    _i++;
                    return [3 /*break*/, 6];
                case 9:
                    if (!!lodash_1.default.isEmpty(newFiles)) return [3 /*break*/, 11];
                    return [4 /*yield*/, updateEvaluationWithFile(type, name, newFiles)];
                case 10:
                    _a.sent();
                    _a.label = 11;
                case 11: return [4 /*yield*/, updateProgressState(type, name, [selectedDetailId], newState)];
                case 12:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.saveEvaluationItem = saveEvaluationItem;
/**
 * state.owner/performer를 변경
  자연스럽게 변경되어야 하는 정보는(RCM 을 수정하는 것이 아니다. 해당 평가가 생성될 당시 첨부한 내용들을 수정하는 것이다)
  변경점(20211027) content.control의 owner, department 는 수정하지 않는다
  평가-내역의 staffData - 전체
 * @param isOwner
 * @param type
 * @param name
 * @param controlId
 * @param staffId
 * @returns
 */
function updateOwnerOrPerformer(isOwner, type, name, controlId, staffId) {
    return __awaiter(this, void 0, void 0, function () {
        var editable, staff, collectionName, contentDoc, stateDoc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(type, name)];
                case 1:
                    editable = _a.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00(".concat(name, ")\uB294 \uC774\uBBF8 \uB9C8\uAC10\uB41C \uD3C9\uAC00\uC774\uAE30 \uB584\uBB38\uC5D0 \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    return [4 /*yield*/, StaffManager.get(staffId)];
                case 2:
                    staff = _a.sent();
                    if (!staff) {
                        return [2 /*return*/, Promise.reject(new Error("\uC874\uC7AC\uD558\uC9C0 \uC54A\uB294 \uC0AC\uC6A9\uC790(".concat(staffId, ")\uC785\uB2C8\uB2E4")))];
                    }
                    collectionName = Evaluation.getKoEvaluation(type);
                    if (!isOwner) return [3 /*break*/, 4];
                    contentDoc = firebase.dbService
                        .collection(collectionName)
                        .doc(name)
                        .collection(EvaluationUtils_1.CONTENT_DOC_NAME)
                        .doc(controlId);
                    return [4 /*yield*/, contentDoc.update({ staff: staff })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    stateDoc = firebase.dbService
                        .collection(collectionName)
                        .doc(name)
                        .collection(EvaluationUtils_1.STATE_DOC_NAME)
                        .doc(controlId);
                    if (!isOwner) return [3 /*break*/, 6];
                    return [4 /*yield*/, stateDoc.update({
                            owner: staffId,
                            department: staff.departmentName
                        })];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, stateDoc.update({
                        performer: staffId
                    })];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
}
exports.updateOwnerOrPerformer = updateOwnerOrPerformer;
function setReference(type, name, refName) {
    return __awaiter(this, void 0, void 0, function () {
        var refBase;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!lodash_1.default.isEmpty(refName)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, EvaluationLoader_1.getBase)(type, refName)];
                case 1:
                    refBase = _a.sent();
                    if (refBase.state !== Evaluation.EvaluationState.Closed) {
                        return [2 /*return*/, Promise.reject(new Error("\uCC38\uC870\uD558\uB824\uB294 \uD3C9\uAC00(".concat(refName, ") \uC740 \uCD5C\uC885\uB9C8\uAC10\uC774 \uB418\uC9C0 \uC54A\uC740 \uC0C1\uD0DC\uC785\uB2C8\uB2E4.")))];
                    }
                    _a.label = 2;
                case 2: return [4 /*yield*/, firebase.dbService.collection(Evaluation.getKoEvaluation(type)).doc(name).update({
                        refEvaluationName: refName
                    })];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.setReference = setReference;
//# sourceMappingURL=EvaluationUpdater.js.map